<template>
  <div class="modalBackground">
    <div class="MultiMessageScheduler">
      <h3>SCHEDULE THIS MESSAGE</h3>
      <div class="messageName">
        <label for="messageName">NAME</label>
        <input
          type="text"
          name="messageName"
          placeholder="Type a name"
          v-model="messageName"
        />
      </div>
      <div class="dateWrapper">
        <label for="MultiMessageSchedulerStartDay">DATE</label>
        <datepicker
          v-model="schedulerStartDate"
          wrapper-class="datePickerOuterWrap"
          input-class="datePickerInput"
          calendar-class="dateCalendar"
          placeholder="Select a Day"
          :disabledDates="disabledDates"
          name="MultiMessageSchedulerStartDay"
        ></datepicker>
        <label for="scheduledHour">HOUR</label>
        <select name="scheduledHour" id="scheduledHour" v-model="scheduledHour">
          <option :value="hour" v-for="hour in hourArray" :key="hour">
            {{ hour }}
          </option>
        </select>
        <label for="messageFrequency">FREQUENCY</label>
        <select name="messageFrequency" v-model="messageFrequency">
          <option
            :value="singleFreq"
            v-for="singleFreq in frequencyArray"
            :key="singleFreq"
          >
            {{ singleFreq }}
          </option>
        </select>
        <label
          for="MultiMessageSchedulerEndDate"
          v-if="messageFrequency !== 'One Time'"
          >OPTIONAL END DATE</label
        >
        <datepicker
          v-model="schedulerEndDate"
          wrapper-class="datePickerOuterWrap"
          input-class="datePickerInput"
          calendar-class="dateCalendarAbove"
          placeholder="Select a Day"
          :disabledDates="disabledDates"
          name="MultiMessageSchedulerEndDate"
          v-if="messageFrequency !== 'One Time'"
        ></datepicker>
      </div>
      <div class="btnRow">
        <button-global
          type="negative"
          text="CANCEL"
          size="medium"
          @eventPassed="$emit('schedulerEvent')"
        ></button-global>
        <button-global
          type="positive"
          text="SCHEDULE"
          size="medium"
          @eventPassed="setScheduledMessage"
        ></button-global>
      </div>
      <fetching-loader
        displayType="displayFixed"
        v-if="schedulingMessage"
      ></fetching-loader>
    </div>
  </div>
</template>

<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import bus from "@/bus.js";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import Datepicker from "vuejs-datepicker";
import returnUTCTimeMixin from "@/mixins/returnUTCTimeMixin";
import convertToUTCMixin from "@/mixins/convertToUTCMixin";
import { firestore } from "@/firebase";

export default {
  name: "MultiMessageScheduler",
  components: {
    ButtonGlobal,
    FetchingLoader,
    Datepicker,
  },
  mixins: [returnUTCTimeMixin, convertToUTCMixin],
  props: {
    messageContent: {
      type: String,
      required: true,
    },
    emailSubject: {
      type: String,
      defualt: "",
    },
    messageType: {
      type: String,
      required: true,
    },
    selectionType: {
      type: String,
      required: true,
    },
    manualRoomSelection: {
      type: Array,
      defualt: [],
    },
  },
  data() {
    return {
      messageName: "",
      schedulingMessage: false,
      schedulerStartDate: null,
      schedulerEndDate: null,
      disabledDates: {
        customPredictor: function (date) {
          var newDateFromObject = new Date().setDate(
            new Date().getUTCDate() - 1
          );
          if (newDateFromObject > date) {
            return true;
          }
        },
      },
      hourArray: [
        "00:00 a.m",
        "01:00 a.m",
        "02:00 a.m",
        "03:00 a.m",
        "04:00 a.m",
        "05:00 a.m",
        "06:00 a.m",
        "07:00 a.m",
        "08:00 a.m",
        "09:00 a.m",
        "10:00 a.m",
        "11:00 a.m.",
        "12:00 p.m",
        "13:00 p.m.",
        "14:00 p.m",
        "15:00 p.m",
        "16:00 p.m",
        "17:00 p.m",
        "18:00 p.m",
        "19:00 p.m",
        "20:00 p.m",
        "21:00 p.m",
        "22:00 p.m",
        "23:00 p.m",
      ],
      scheduledHour: "11:00 a.m.",
      frequencyArray: ["One Time", "Daily", "Weekly"],
      messageFrequency: "One Time",
    };
  },
  created() {
    this.schedulerStartDate = new Date().setDate(new Date().getUTCDate());
  },
  methods: {
    setScheduledMessage() {
      this.schedulingMessage = true;
      const utcTimeStampConverted = this.returnUTCTime();
      const formatedDate = new Date(utcTimeStampConverted).toISOString();

      var multimessageDocRef = firestore
        .collection("MultimessageScheduler")
        .doc(`${this.$hotelId}`)
        .collection("ScheduledMessages")
        .doc();

      multimessageDocRef
        .set({
          createdAt: formatedDate,
          sendingAt: this.convertToUTC(this.schedulerStartDate),
          endingAt: this.convertToUTC(this.schedulerEndDate),
          messageType: this.messageType,
          messageName: this.messageName,
          selectionType: this.selectionType,
          messageFrequency: this.messageFrequency,
          scheduledHour: this.scheduledHour,
          roomList:
            this.selectionType === "MANUAL SELECTION"
              ? this.manualRoomSelection
              : null,
          messageContent: this.messageContent,
          subjectContent: this.messageType === "SMS" ? null : this.emailSubject,
          documentID: multimessageDocRef.id,
          customerID: this.$customerId,
          // hotelLocation: this.$hotelLocationInitals,
        })
        .then(() => {
          this.schedulingMessage = false;
          bus.$emit("closeMultiMessage");
          // this.$emit('schedulerEvent');
          // this.$emit('closeModal');
          this.$router.push({ name: "room-messages" });
        });
    },
  },
};
</script>

<style scoped>
h3,
label {
  color: #707070;
  font-weight: bold;
}
h3 {
  font-size: 1.2em;
}
label {
  margin: 10px 0;
}
.modalBackground {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1005;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.MultiMessageScheduler {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  width: 32vw;
  min-height: 75vh;
  border-radius: 5px;
  padding: 15px 35px 30px 35px;
}
.datePickerOuterWrap {
  height: 45px;
  width: 200px;
}
.dateWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  margin-top: 10px;
}
.dateWrapper label {
  margin-top: 32px;
}
select,
input,
.datePickerOuterWrap >>> input {
  border: 1px solid #707070;
  background-color: #ffffff;
  width: 200px;
  height: 40px;
  padding: 7px 18px;
  border-radius: 5px;
}
.messageName {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 10px;
}
.btnRow {
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
  margin-top: 20px;
}
</style>
